/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2017-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, { Component } from 'react';
import {Tooltip, OverlayTrigger, Button} from 'react-bootstrap';

import './BlueButton.scss';

class BlueButton extends Component {
    render() { 
        let {type, click, title, className, style, shouldBeVisible, srcPath, isDisabled, tooltipText, placement, dataTestId} = this.props;
        const btnClassName = className ? className + ' btn-blue ' : ' btn-blue ';
        srcPath = srcPath ? srcPath : "";
        style = tooltipText ? {pointerEvents: "none", ...style} : style
        const logoInBtnTmpl = <img src={srcPath} role="presentation" alt="logo"/>;
        const clk = click ? {onClick: click} : {};
        const over = <Tooltip id="tooltip">{tooltipText}</Tooltip>;
        let tpl = 
        <Button type={type ? type : (click ? 'button' : 'submit')} variant="primary" className={btnClassName} style={style} {...clk} disabled={isDisabled} {...(dataTestId ? {'data-testid': dataTestId} : {})}>
            {this.props.children}
        {srcPath !== "" ? logoInBtnTmpl : null}
        {title}
        </Button>
        tpl = tooltipText ? 
            (<OverlayTrigger placement={placement} overlay={over}> 
                <div style={{display: "inline-block"}}>
                    {tpl}
                </div>
            </OverlayTrigger>) : tpl;
        // return the button only if shouldBeVisible does not exist or it returns true
        // if shouldBeVisible returns false then hide the button
        return !shouldBeVisible || (shouldBeVisible && shouldBeVisible() === true) ? tpl : null;
    }
}

export default BlueButton;
